import { getTauriDesktopOs, type TauriDesktopOs } from './platform';

/** "this Mac" | "this PC" | "this computer" */
export function thisHostPhrase(os: TauriDesktopOs = getTauriDesktopOs()): string {
  if (os === 'windows') return 'this PC';
  if (os === 'linux') return 'this computer';
  return 'this Mac';
}

/** "home Mac" | "home PC" | "home computer" */
export function homeHostPhrase(os: TauriDesktopOs = getTauriDesktopOs()): string {
  if (os === 'windows') return 'home PC';
  if (os === 'linux') return 'home computer';
  return 'home Mac';
}

/** Neutral label when the viewer does not know the host OS. */
export const HOME_HOST_NEUTRAL = 'home computer';

export function doThisNowOnHost(os: TauriDesktopOs = getTauriDesktopOs()): string {
  return `Do this now on ${thisHostPhrase(os)}`;
}

export function scanLibraryOnHost(os: TauriDesktopOs = getTauriDesktopOs()): string {
  return `Scan your music library on ${thisHostPhrase(os)}`;
}

export function backgroundServiceOnHost(os: TauriDesktopOs = getTauriDesktopOs()): string {
  return `Installs a background service on ${thisHostPhrase(os)} so other devices can reach your library — Maestro does not need to stay open.`;
}

export function browseLocalOnHost(os: TauriDesktopOs = getTauriDesktopOs()): string {
  return `Browse and play files from your NAS or local storage on ${thisHostPhrase(os)}.`;
}

export function libraryOnHost(os: TauriDesktopOs = getTauriDesktopOs()): string {
  return `Your library is on ${thisHostPhrase(os)}`;
}

export function wakeHostPhrase(os: TauriDesktopOs = getTauriDesktopOs()): string {
  if (os === 'windows') return 'wake this PC';
  if (os === 'linux') return 'wake this computer';
  return 'wake this Mac';
}

export function hostOnlineLabel(os: TauriDesktopOs = getTauriDesktopOs()): string {
  if (os === 'windows') return 'Home PC online — library not ready';
  if (os === 'linux') return 'Home computer online — library not ready';
  return 'Home Mac online — library not ready';
}

/** LAN permission / firewall — same-network devices (iOS, multizone), not internet tunnel. */
export function allowLocalNetworkAccessLabel(_os?: TauriDesktopOs): string {
  return 'Allow devices on this network to reach your library';
}

/** @deprecated Use allowLocalNetworkAccessLabel — kept for remote-access re-enable branch. */
export function prepareNetworkAccessLabel(os: TauriDesktopOs = getTauriDesktopOs()): string {
  return allowLocalNetworkAccessLabel(os);
}
